import { TFunction } from "i18next";

export type OnboardingOption = { slug: string; text: string };

export const getOnboardingEventOptions = (t: TFunction): OnboardingOption[] => [
    { slug: "snidane", text: t("onboarding.steps.3.event.snidane") },
    { slug: "brunch", text: t("onboarding.steps.3.event.brunch") },
    { slug: "dopoledni_coffee_break", text: t("onboarding.steps.3.event.dopoledni_coffee_break") },
    { slug: "obed", text: t("onboarding.steps.3.event.obed") },
    { slug: "odpoledni_coffee_break", text: t("onboarding.steps.3.event.odpoledni_coffee_break") },
    { slug: "vecere", text: t("onboarding.steps.3.event.vecere") },
    { slug: "welcome_drink", text: t("onboarding.steps.3.event.welcome_drink") },
    { slug: "afterparty", text: t("onboarding.steps.3.event.afterparty") },
    { slug: "grilovani", text: t("onboarding.steps.3.event.grilovani") },
];

export const getOnboardingDietOptions = (t: TFunction): OnboardingOption[] => [
    { slug: "vegetarianska", text: t("onboarding.steps.8.diets.vegetarian") },
    { slug: "veganska", text: t("onboarding.steps.8.diets.vegan") },
    { slug: "bezlepkova", text: t("onboarding.steps.8.diets.gluten_free") },
    { slug: "paleo", text: t("onboarding.steps.8.diets.paleo") },
    { slug: "keto", text: t("onboarding.steps.8.diets.keto") },
];

export const getOnboardingPackagingMap = (t: TFunction) => ({
    Paper: t("onboarding.steps.5.buttons.paper"),
    Premium: t("onboarding.steps.5.buttons.porcelain"),
});
